/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import ContentIndicator from 'components/shared/contentindicator/contentindicator_container';
import PointIndicator from 'components/shared/pointindicator/pointindicator_container';
// import Bullets from 'components/shared/bullets/bullets_container';
import PartnerLogo from 'components/shared/logo/partner/partner_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/header/header_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ HEADER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Header extends Component {
    render() {
        let elSettings = this.props.currentContentSettings.elements.header;
        if (!elSettings) { return false; }
        return (
            <div className={`${sheet.classes.header} header large-${this.props.enlargedFont}`}>
                <div className={`inner`}>
                    <div className={`${sheet.classes.group} ${sheet.classes.left}`}>
                        {elSettings.indicator.visible === true ? <ContentIndicator contentId={this.props.contentId} /> : null}
                        {this.props.rewardsEnabled && this.props.rewardsPermitted ? <PointIndicator contentId={this.props.contentId} /> : null}
                    </div>
                    <div className={`${sheet.classes.group} ${sheet.classes.right}`}>
                        {elSettings.partnerLogo.visible === true ? <PartnerLogo contentId={this.props.contentId} /> : null}
                    </div>
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Header;
